module.exports = __webpack_public_path__ + "img/header-top.324ec02a.png";